import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import Dispatcher from './dispatcher';
import selector from './selector';
import Utils from './utils';

const useReservations = () => {
    const dispatcher = new Dispatcher(useDispatch());
    const state = useSelector(selector, shallowEqual);
    const utils = new Utils(state, dispatcher);

    return [state, dispatcher, utils];
}


export default useReservations;